<template>
  <div v-if="!isloading" id="avatar-students">
    <template v-for="(student, index) in students" :key="index">
      <span v-if="index <= 4">
        <span v-if="student.picture" :class="`avatar-student avatar-${index+1}`">
          <SingleAvatarStudent
            size="32px"
            :picture="student.picture.format.small"
            :short-name="student.shortName"
            :gender="student.gender"
          />
        </span>
        <span v-if="!student.picture && student.alt" :class="`avatar-student avatar-${index+1}`">
          <SingleAvatarStudent
            size="32px"
            :bo-alt="student.alt"
            :gender="student.gender"
          />
        </span>
        <span v-if="!student.picture && !student.alt" :class="`avatar-student avatar-${index+1}`"/>
        <div v-if="more > 0" class="avatar-student avatar-5">
          <div class="more">
            +{{ more }}
          </div>
        </div>
      </span>
    </template>
  </div>
</template>

<script>

import SingleAvatarStudent from '../MyStudents/SingleAvatarStudent';

export default {
  components: {
    SingleAvatarStudent,
  },
  props: ['students', 'studentAsked'],
  data() {
    return {
      more: 0,
      studentCount: 0,
      isloading: true,
    };
  },
  watch: {

    students: {
      handler() {
        this.generateStudent();
      },
      deep: true,
    },
    studentAsked: {
      handler() {
        this.generateStudent();
      },
    },
  },
  mounted() {
    this.studentCount = this.studentAsked;
    if (this.studentAsked > 5) {
      this.more = this.studentAsked - 4;
    }
    this.generateStudent();
  },
  methods: {
    generateStudent() {
      for (let i = 0; i < this.studentAsked; i += 1) {
        if (!this.students[i]) {
          this.students[i] = { format: { small: null }, color: true };
        }
      }
      this.isloading = false;
    },
  },
};

</script>
